'use strict';

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var isBrowser = typeof window !== 'undefined' && window.fetch;
var thisFetch = null;

if (isBrowser) {
  thisFetch = window.fetch;
} else if (typeof fetch !== 'undefined') {
  // react-native
  thisFetch = fetch;
} else if (process.env.NODE_ENV === 'test') {
  thisFetch = require('node-fetch');
}

var FetchError = function (_Error) {
  (0, _inherits3.default)(FetchError, _Error);

  function FetchError(msg, response) {
    (0, _classCallCheck3.default)(this, FetchError);

    var _this = (0, _possibleConstructorReturn3.default)(this, (FetchError.__proto__ || Object.getPrototypeOf(FetchError)).call(this, msg));

    _this.response = response;
    return _this;
  }

  (0, _createClass3.default)(FetchError, [{
    key: 'text',
    value: function () {
      var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
        return _regenerator2.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                return _context.abrupt('return', this.response.text());

              case 1:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function text() {
        return _ref.apply(this, arguments);
      }

      return text;
    }()
  }, {
    key: 'json',
    value: function () {
      var _ref2 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2() {
        return _regenerator2.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                return _context2.abrupt('return', this.response.json());

              case 1:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function json() {
        return _ref2.apply(this, arguments);
      }

      return json;
    }()
  }, {
    key: 'status',
    get: function get() {
      return this.response.status;
    }
  }, {
    key: 'statusText',
    get: function get() {
      return this.response.statusText;
    }
  }]);
  return FetchError;
}(Error);

var myFetch = function () {
  var _ref3 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee3(url) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var result;
    return _regenerator2.default.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            _context3.next = 2;
            return thisFetch(url, options);

          case 2:
            result = _context3.sent;

            if (!result.ok) {
              _context3.next = 7;
              break;
            }

            return _context3.abrupt('return', result);

          case 7:
            throw new FetchError('Error fetching ' + url, result);

          case 8:
          case 'end':
            return _context3.stop();
        }
      }
    }, _callee3, undefined);
  }));

  return function myFetch(_x2) {
    return _ref3.apply(this, arguments);
  };
}();

var fetchJson = function () {
  var _ref4 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee4(url) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return _regenerator2.default.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            options.headers = (0, _extends3.default)({
              'Content-Type': 'application/json; charset=utf-8'
            }, options.headers);

            if (isBrowser) {
              options.credentials = 'same-origin'; // change to 'include' if want to disregard
            }

            if (options.body && typeof options.body !== 'string') {
              options.body = JSON.stringify(options.body);
            }

            return _context4.abrupt('return', myFetch(url, options));

          case 4:
          case 'end':
            return _context4.stop();
        }
      }
    }, _callee4, undefined);
  }));

  return function fetchJson(_x4) {
    return _ref4.apply(this, arguments);
  };
}();

module.exports = {
  fetch: myFetch,
  fetchJson: fetchJson,
  FetchError: FetchError
};